import local from './local';
import staging from './staging';
import production from './production';

let config;

if (process.env.NODE_ENV === 'production') {
  config = production();
} else if (process.env.NODE_ENV === 'staging') {
  config = staging();
} else {
  config = local();
}

export const {
  baseURL,
  clientHost,
  FB_APP_ID,
  firebaseConfig,
  stripeConfig,
  getTemplateCategories,
} = config;
